// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { fetch } from "@insite/client-framework/ServerSideRendering";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const mfaUrl = "/api/v1/mfa";

export interface AccessTokenResult {
    accessToken: string;
}

export interface MfaChallengeResult {
    mfaRequired: boolean;
    challengeId: string;
    maskedEmail: string;
    expiresInSeconds: number;
    codeLength: number;
}

export interface MfaVerifyApiParameter {
    challengeId: string;
    code: string;
}

export interface MfaVerifyResult {
    verified: boolean;
    ticketId: string;
    ticketExpiresInSeconds: number;
    attemptsRemaining: number;
}

export async function requestAccessToken(
    userName: string,
    password: string,
): Promise<ServiceResult<AccessTokenResult>> {
    const data = new URLSearchParams();
    data.append("grant_type", "password");
    data.append("username", userName);
    data.append("password", password);
    data.append("scope", "iscapi offline_access");

    const response = await fetch("/identity/connect/token", {
        method: "POST",
        body: data.toString(),
        headers: new Headers({
            "content-type": "application/x-www-form-urlencoded",
            Authorization: `Basic ${btoa("isc:009AC476-B28E-4E33-8BAE-B5F103A142BC")}`,
        }),
    });

    const json = (await response.json()) as {
        readonly access_token: string;
        readonly error_description?: string;
    };

    if (!response.ok) {
        return {
            successful: false,
            errorMessage: json.error_description,
            statusCode: response.status,
        };
    }

    return {
        successful: true,
        result: { accessToken: json.access_token },
    };
}

export async function requestMfaChallenge(accessToken: string): Promise<ServiceResult<MfaChallengeResult>> {
    const response = await fetch(`${mfaUrl}/challenge`, {
        method: "POST",
        body: JSON.stringify({}),
        headers: new Headers({
            "content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
        }),
    });

    if (!response.ok) {
        let errorMessage: string | undefined;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorMessage = (await response.json())?.message;
        } else {
            errorMessage = await response.text();
        }

        return {
            successful: false,
            errorMessage,
            statusCode: response.status,
        };
    }

    const result = (await response.json()) as MfaChallengeResult;
    return {
        successful: true,
        result,
    };
}

export async function verifyMfa(parameter: MfaVerifyApiParameter): Promise<ServiceResult<MfaVerifyResult>> {
    try {
        const result = await post<MfaVerifyApiParameter, MfaVerifyResult>(`${mfaUrl}/verify`, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson?.message ?? error.errorMessage,
                statusCode: error.status,
            };
        }
        throw error;
    }
}
